import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperClass } from 'swiper'; // SwiperClass をインポート
import 'swiper/swiper-bundle.css';

interface ImageSliderSimpleProps {
  images: { src: string; title: string }[]; // 親から受け取る画像とタイトル
}

export const ImageSliderSimple: React.FC<ImageSliderSimpleProps> = ({
  images,
}) => {
  const [currentSlide, setCurrentSlide] = useState(1); // 現在のスライドインデックス

  return (
    <div className="w-full">
      <Swiper
        onSlideChange={(swiper: SwiperClass) =>
          setCurrentSlide(swiper.activeIndex + 1)
        }
        slidesPerView={1}
        loop={true}
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <img
              src={image.src}
              alt={image.title}
              className="w-full h-auto object-cover"
            />
            <div className="flex justify-between">
              <p className="text-left">{image.title}</p>
              {/* <p className="text-right">
                {currentSlide}/{images.length}
              </p> */}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
